import { useState, useCallback } from "react";
import { useFetcher } from "rest-hooks";
import { BuyoutGetContractEndpoint, isErrorFromBuyoutGetContract, isSuccessFromBuyoutGetContract } from "../endpoints/BuyoutGetContract";
export const useBuyoutGetContract = () => {
    const [contract, setContract] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const getContract = useFetcher(BuyoutGetContractEndpoint);
    const handleGetContract = useCallback(async (registrationNumber) => {
        const trimmedRegNumber = registrationNumber.trim();
        if (trimmedRegNumber.length < 1) {
            setError("Registration number is required");
            return;
        }
        setIsLoading(true);
        setError(null);
        setContract(null);
        try {
            const result = await getContract({
                registrationNumber: trimmedRegNumber
            });
            if (isErrorFromBuyoutGetContract(result)) {
                console.error("Errors:", result.errors);
                setError(result?.errors ? result?.errors.join(", ") : "Unknown error");
                return;
            }
            if (!isSuccessFromBuyoutGetContract(result)) {
                console.error("Unexpected response format:", result);
                setError("Unexpected response format");
                return;
            }
            const parsedDates = result.BuyoutDates.map(normalizeToUtcDate);
            const endDate = normalizeToUtcDate(result.EndDate);
            var kilometerReadingResult = result.KilometerReadingResult ?? undefined;
            setContract({
                contractNumber: result.ContractNumber,
                buyoutDates: parsedDates,
                endDate: endDate,
                allowedMileage: result.AllowedMileage,
                kilometerReadingResult: kilometerReadingResult
            });
        }
        catch (error) {
            setError("Failed to fetch contract data");
            console.error("Error fetching contract data:", error);
        }
        finally {
            setIsLoading(false);
        }
    }, [getContract]);
    const reset = useCallback(() => {
        setContract(null);
        setError(null);
    }, []);
    return {
        contract,
        isLoading,
        error,
        handleGetContract,
        reset
    };
};
function normalizeToUtcDate(dateString) {
    const endsWithZ = dateString.endsWith("Z");
    const hasOffset = dateString.length >= 6 && dateString[dateString.length - 6] === "+";
    if (!endsWithZ && !hasOffset) {
        return new Date(dateString + "Z");
    }
    return new Date(dateString);
}
//# sourceMappingURL=useBuyoutGetContract.js.map